//TODO : A SUPPRIMER

//TODO : Travailler sur l'annulsation des abos web avec RevenueCat
export const cancelSubscriptionFromWeb = async (data: { userSub: any, user_id: string }) => {
    
}